import { createSelector } from '@reduxjs/toolkit';
import { EachAssigneesRes } from 'store/models/Assignees';
import AuthUser from 'store/models/AuthUser';

export const authSelector = (state) => state.authentication;
export const userDataSelector = createSelector(
  authSelector,
  (storeAuth) => storeAuth.user,
);
export const isUserAdminSelector = createSelector(
  userDataSelector,
  (user) => user?.isAdmin ?? false,
);

export const userDataAsAssigneeSelector = createSelector(
  authSelector,
  (storeAuth): undefined | EachAssigneesRes =>
    storeAuth.user &&
    new AuthUser(storeAuth.user).toEachAssigneeRes(),
);
